var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToolTip({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7951_13615",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.4502 14.0002C2.4502 7.62131 7.6213 2.4502 14.0002 2.4502C20.3791 2.4502 25.5502 7.62131 25.5502 14.0002C25.5502 20.3791 20.3791 25.5502 14.0002 25.5502C7.6213 25.5502 2.4502 20.3791 2.4502 14.0002ZM15.1668 19.2502C15.1668 19.8946 14.6445 20.4169 14.0002 20.4169C13.3558 20.4169 12.8335 19.8946 12.8335 19.2502C12.8335 18.6059 13.3558 18.0836 14.0002 18.0836C14.6445 18.0836 15.1668 18.6059 15.1668 19.2502ZM15.7793 8.09534C15.1769 7.8118 14.5101 7.6782 13.8423 7.70314C13.1745 7.72808 12.52 7.91107 11.9421 8.24011C11.3638 8.56936 10.8773 9.03656 10.5388 9.6045C10.1998 10.1733 10.0233 10.8202 10.034 11.4812L12.1337 11.4473C12.1295 11.185 12.1989 10.921 12.3427 10.6796C12.4871 10.4374 12.704 10.2228 12.9811 10.065C13.2586 9.90705 13.5824 9.81431 13.9207 9.80168C14.2589 9.78905 14.5916 9.85729 14.885 9.99538C15.1781 10.1333 15.4163 10.3334 15.584 10.5673C15.7511 10.8003 15.8441 11.0607 15.8631 11.3228C15.8822 11.5846 15.8277 11.8504 15.6987 12.0961C15.5705 12.3406 15.3702 12.5616 15.1078 12.7305C14.4695 13.1222 13.9313 13.6511 13.5433 14.2809C13.1528 14.9146 12.927 15.6302 12.8907 16.3694L12.8894 16.3952V16.771H14.9894V16.4493C15.0115 16.0798 15.1263 15.7149 15.3311 15.3825C15.5406 15.0425 15.8401 14.7438 16.212 14.5168L16.2207 14.5115L16.2294 14.506C16.7901 14.1485 17.2513 13.6571 17.5584 13.0717C17.8659 12.4855 18.0056 11.8298 17.9576 11.1704C17.9097 10.5113 17.6767 9.88205 17.2907 9.34363C16.9052 8.80601 16.382 8.37902 15.7793 8.09534Z",
    fill: "#1B1C1E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7951_13615)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "#EAEBEC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolTip);
export default __webpack_public_path__ + "static/media/toolTip.dbd62dae811e47c838b308c243ec0b52.svg";
export { ForwardRef as ReactComponent };